<template>
  <v-layout class="my-2 align-center" row wrap>
    <v-flex xs4>{{ splitByAllCapitalLetters(field.Field) }}</v-flex>
    <v-flex xs8>
      <v-chip label small icon="pageview">
        <v-icon class="mr-1">event_note</v-icon>
        <a href="#" @click.prevent="goToExecutionId" >{{ field.FieldValue }}</a>
      </v-chip>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const imports = createNamespacedHelpers('imports')
  import { splitByAllCapitalLetters } from '@/helpers/strings'
  export default {
    props: {
      field: Object,
    },
    methods: {
      ...imports.mapActions(['fetchImportByExecutionId']),
      splitByAllCapitalLetters,
      async goToExecutionId() {
        let executionId  = this.field.FieldValue
        let importResult = await this.fetchImportByExecutionId({
          executionId: executionId,
        })

        if(importResult == null || importResult.FileType != 'A125') {
          this.$router.push({
            name: 'allimports',
            query: { search: this.field.FieldValue }, // Optional query parameters
          })
        } else {
          this.$router.push({
            name: 'import',
            params: { importId: importResult.Id }, // Optional query parameters
          })
        }
      },
    },
  }
</script>